import React, { useState, useEffect } from 'react';
import './Courses.css'
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '50ch',
        },
    },
}));


function Courses() {

    const [open, setOpen] = React.useState(false);
    const [assignopen, openAssign] = React.useState(false);

    // useEffect(() => {
    // async function fetchCourses(){
    //     const response = await fetch('')
    // }
    // }, [])

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const AssignOpen = () => {
        openAssign(true);
    };
    const AssignClose = () => {
        openAssign(false);
    };

    const classes = useStyles();

    const srtingEmptyCheck = (strValue) => {
        if (!strValue.trim().length) {
            return false
        }
        else {
            return true
        }
    }

    const validateforms = () => {
        var Courseid = document.getElementById("courseid").value;
        var Couname = document.getElementById("cname").value;

        if (srtingEmptyCheck(Courseid) === false) {
            document.getElementById("id_error").innerHTML = "<span style='color:red;'>Please enter a vaild course id</span>";
        }
        else {
            document.getElementById("id_error").innerHTML = "<span></span>";
        }
        if (srtingEmptyCheck(Couname) === false) {
            document.getElementById("course_error").innerHTML = "<span style='color:red;'>Please enter a vaild course name</span>";
        }
        else {
            document.getElementById("course_error").innerHTML = "<span></span>";
        }
        if (srtingEmptyCheck(Courseid) && srtingEmptyCheck(Couname)) {
            alert("Course details have been added")
            handleClose()
        }
    }

    const validateassign = () => {
        alert("School details have been added")
        AssignClose()
    }

    return (
        <div className="coursemain">
            <div className="course_buttonmain" onClick={handleClickOpen}>
                Add New
                </div>
            <table id="course_table">
                <tr>
                    <th>ID</th>
                    <th>Course Name</th>
                    <th>Active</th>
                    <th></th>
                </tr>
                <tr>
                    <td>1</td>
                    <td>case silver</td>
                    <td>Yes</td>
                    <td><div className="course_assign" onClick={AssignOpen}>Assign Class</div></td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>Artifical intelligence</td>
                    <td>Yes</td>
                    <td><div className="course_assign" onClick={AssignOpen}>Assign Class</div></td>
                </tr>
                <tr>
                    <td>3</td>
                    <td>machine learning</td>
                    <td>Yes</td>
                    <td><div className="course_assign" onClick={AssignOpen}>Assign Class</div></td>
                </tr>
                <tr>
                    <td>4</td>
                    <td>case silver</td>
                    <td>No</td>
                    <td><div className="course_assign" onClick={AssignOpen}>Assign Class</div></td>
                </tr>
                <tr>
                    <td>5</td>
                    <td>Artifical intelligence</td>
                    <td>No</td>
                    <td><div className="course_assign" onClick={AssignOpen}>Assign Class</div></td>
                </tr>
                <tr>
                    <td>6</td>
                    <td>machine learning</td>
                    <td>No</td>
                    <td><div className="course_assign" onClick={AssignOpen}>Assign Class</div></td>
                </tr>
            </table>
            <div>
                <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
                    <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                        Course Details
                    </DialogTitle>
                    <DialogContent dividers>
                        <form style={{ padding: '0vw 4vw' }} autocomplete="off">
                            <input id="courseid" className="input_courses" type="text" placeholder="Course ID" /><br></br>
                            <div className="error_message" id='id_error'></div>
                            <input id="cname" className="input_courses" type="text" placeholder="Course Name" />
                            <div className="error_message" id='course_error'></div>
                        </form>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={validateforms}>
                            Create
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
            <div>
                <Dialog onClose={AssignClose} aria-labelledby="customized-dialog-title" open={assignopen}>
                    <DialogTitle id="customized-dialog-title" onClose={AssignClose}>
                        School Details
                </DialogTitle>
                    <DialogContent dividers>
                        <form style={{ padding: '0vw 4vw' }} autocomplete="off">
                            <input id="courseid" className="input_courses" type="text" placeholder="School Name" /><br></br>
                            <div className="error_message" id='school_error'></div>
                        </form>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={validateassign}>
                            Create
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </div>
    );
}

export default Courses;

